import { type ComputedRef, inject, type InjectionKey } from "vue";

/**
 * Provided by BaseCheckboxGroup to the BaseCheckboxes it wraps. The group takes the surrounding
 * FormField's id, label and hint/error wiring, so each checkbox keeps its own id and inline label
 * and mirrors the field's invalid state and description.
 */
export interface CheckboxGroupContext {
    invalid: ComputedRef<boolean>;
    /** The field's hint and error ids, so an invalid checkbox says what to fix when focused directly. */
    describedBy: ComputedRef<string | undefined>;
}

export const checkboxGroupContextKey: InjectionKey<CheckboxGroupContext> = Symbol("checkboxGroupContext");

/** Returns the surrounding BaseCheckboxGroup's context, or null outside a group. */
export function useCheckboxGroup(): CheckboxGroupContext | null {
    return inject(checkboxGroupContextKey, null);
}
